import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import { HiOutlinePlus, HiOutlineMinus } from "react-icons/hi";
import Image from "next/image";
import { useState } from "react";
import Link from "next/link";
import { CLMButtonPrimary } from "../v3/Buttons";
import {
  capterraCertifications,
  certifications,
} from "@constants/certifications";
import { BASE_ASSETS_URL } from "@constants/constants";
import Certifications from "@components/Security/Certifications";
import { FaXTwitter } from "react-icons/fa6";

const CLMFooter = () => {
  const [openSections, setOpenSections] = useState([]);

  const toggleSection = (heading) => {
    setOpenSections((prev) =>
      prev.includes(heading)
        ? prev.filter((item) => item !== heading)
        : [...prev, heading]
    );
  };

  const footerElements = [
    {
      heading: "Company",
      content: [
        { title: "About Us", link: "/about" },
        { title: "Customers", link: "/customers" },
        // { title: "Affiliate Program", link: "/signature/affiliates" },
        // { title: "Whitelabel Partnership", link: "/signature/whitelabel" },
        { title: "Enterprise", link: "/signature/enterprise" },
        { title: "SOC 2 Compliance", link: "/signature/soc" },
      ],
    },
    {
      heading: "Solutions",
      content: [
        {
          title: "Sign Documents Online",
          link: "https://signature.boloforms.com",
        },
        // { title: "ThePDFMaker", link: "https://thepdfmaker.com/" },
        { title: "Document Signing API", link: "/signature/api" },
        { title: "Embedding", link: "/signature/embedding" },
        {
          title: "Accept Payments",
          link: "/blog/connect-to-stripe-and-accept-payments-in-bolosign",
        },
        {
          title: "WordPress Integration",
          link: "/signature/wordpress-integration",
        },
        { title: "Mobile Apps", link: "/signature/mobile" },
      ],
    },
    {
      heading: "Resources",
      content: [
        {
          title: "What is an eSignature?",
          link: "/signature/what-is-electronic-signature/",
        },
        {
          title: "Are eSignatures legal?",
          link: "/signature/electric-signature-legality",
        },
        { title: "Comparisons", link: "/signature/alternatives" },
        { title: "Blogs", link: "/blog/page/1" },
        {
          title: "Online Signature Maker",
          link: "/signature/online-signature",
        },
        { title: "PDF Tools", link: "/signature/pdf-tools" },
        { title: "Calculators", link: "/calculators" },
      ],
    },
    {
      heading: "Legal & Security",
      content: [
        { title: "Terms of Service", link: "/terms-of-service" },
        { title: "Privacy Policy", link: "/privacy-policy" },
        { title: "Refund Policy", link: "/refund-policy" },
        {
          title: "Data Security & Policy",
          link: "https://security.boloforms.com/",
        },
      ],
    },
    {
      heading: "Sales Inquiry",
      content: [
        { title: "+1 (415) 6496611", link: "tel:+14156496611" },
        // { title: "8 AM - 7 PM (ET)", link: "#" },
      ],
    },
  ];
  const socialLinks = [
    {
      title: "Facebook",
      url: "https://www.facebook.com/boloforms/",
      icon: <FaFacebookF />,
    },
    {
      title: "Instagram",
      url: "https://www.instagram.com/boloforms/",
      icon: <FaInstagram />,
    },
    {
      title: "Twitter",
      url: "https://x.com/BoloForms",
      icon: <FaXTwitter />,
    },
    {
      title: "LinkedIn",
      url: "https://www.linkedin.com/company/boloforms/",
      icon: <FaLinkedinIn />,
    },
  ];
  const AvailabilityLinks = () => (
    <div className="col-span-1 pt-6 md:pt-0 border-t border-gray-400 md:border-none">
      <p className="text-xl font-semibold uppercase mb-3 md:mb-4 px-2">
        Available On
      </p>

      <div className="grid grid-cols-1  gap-2">
        {/* iOS App Store */}
        <Link href="https://apps.apple.com/app/bolosign-upload-sign-send/id6717583531">
          <Image
            src={`${BASE_ASSETS_URL}/v2/clm/footer/apple-store.png`}
            className="w-32 h-auto"
            width={20}
            height={20}
            loading="lazy"
            alt="Download on the App Store"
          />
        </Link>

        {/* Google Play */}
        <Link href="https://play.google.com/store/apps/details?id=com.boloforms.signature">
          <Image
            src={`${BASE_ASSETS_URL}/v2/clm/footer/play-store.png`}
            className="w-32 h-auto"
            width={20}
            height={20}
            loading="lazy"
            alt="Get it on Google Play"
          />
        </Link>

        {/* Google Workspace Marketplace */}
        <Link
          href="https://workspace.google.com/marketplace/app/signature_in_google_forms_by_bolo_sign_p/147316795411"
          className="w-32 h-12 bg-white rounded-md flex items-center border border-surface-dark px-3"
        >
          <Image
            src={`${BASE_ASSETS_URL}/v2/clm/footer/gsuite.png`}
            className="h-5 w-auto"
            width={20}
            height={20}
            loading="lazy"
            alt="Install from Workspace Marketplace"
          />
        </Link>

        {/* Chrome Web Store for Gmail add-on */}
        <Link
          href="https://chromewebstore.google.com/detail/bolosign-for-gmail-esigna/epnpemncgmeholkoakbhhdhniahggpna"
          className="w-32 h-12 bg-white rounded-md flex items-center border border-surface-dark px-3"
        >
          <Image
            src={`${BASE_ASSETS_URL}/v2/clm/footer/gmail.png`}
            className="h-5 w-auto"
            width={20}
            height={20}
            loading="lazy"
            alt="Add to Gmail"
          />
        </Link>
      </div>
    </div>
  );
  return (
    <>
      <div className="bg-white text-black py-16  md:px-10 px-4 xl:px-20 text-center  ">
        <h1 className="text-4xl md:text-7xl font-semibold leading-snug md:mt-20 mt-4 max-w-screen-xl md:px-16 mx-auto mb-10 tracking-tight">
          Ready to streamline your contract management with AI?
        </h1>
        <CLMButtonPrimary
          buttonText="Contact Sales"
          buttonUrl="/clm/request-demo"
        />
      </div>
      <div className="bg-surface-light text-sm w-full ">
        <div className="max-w-screen-xl mx-auto pt-16 pb-8 px-4 md:px-8">
          {/* Desktop View */}
          <section className="hidden md:flex py-16 max-w-screen-xl mx-auto gap-12">
            <div className="w-[30%] ">
              <Image
                src={`${BASE_ASSETS_URL}/v2/clm/clm/BoloSign.png`}
                alt="review"
                className="h-auto mb-2 w-3/4"
                width={100}
                height={100}
                loading="lazy"
              />
              <p className="text-base text-gray-800 my-3 ">
                AI assistant to draft, review, and eSign contracts on autopilot
                for fastest growing companies.
              </p>
              <p className="py-4 text-lg font-medium">
                Email:{" "}
                <Link
                  href="mailto:support@boloforms.com"
                  className="hover:text-primary"
                >
                  support@boloforms.com
                </Link>
              </p>
              <div className="flex gap-4 mb-3 text-4xl md:text-2xl text-black md:text-gray-900">
                {socialLinks.map((link, index) => (
                  <Link
                    key={index}
                    href={link.url}
                    rel="noreferrer"
                    target="_blank"
                    className="text-dark text-sm border border-dark grid place-items-center rounded-full w-8 h-8 transition-all dur hover:bg-dark hover:text-white hover:border-dark"
                  >
                    <span className="sr-only">{link.title}</span>
                    {link.icon}
                  </Link>
                ))}
              </div>
              <div className="flex items-center justify-start gap-4 mt-4">
                {capterraCertifications.map((certification, index) => (
                  <div
                    className="flex flex-col gap-3 justify-end items-center"
                    key={index}
                  >
                    <Image
                      alt={certification?.name}
                      src={certification?.image}
                      width={80}
                      height={80}
                      className="h-16 w-auto"
                      unoptimized
                    />
                  </div>
                ))}
              </div>
            </div>

            <div className="w-[70%] grid xl:grid-cols-3 grid-cols-2  gap-2 text-sm ">
              {(() => {
                const itemsPerColumn = 1;
                const columns = [];

                for (
                  let i = 0;
                  i < footerElements.length;
                  i += itemsPerColumn
                ) {
                  columns.push(footerElements.slice(i, i + itemsPerColumn));
                }

                return columns.map((columnItems, colIndex) => (
                  <div key={colIndex}>
                    {columnItems.map((item, itemIndex) => (
                      <div key={itemIndex} className="mb-3">
                        <p className="text-dark text-xl mb-4 font-semibold uppercase px-2">
                          {item.heading}
                        </p>
                        <div className="flex flex-col gap-[2px]">
                          {item.content.map((contentItem, i) => (
                            <Link
                              href={contentItem?.link || "#"}
                              key={i}
                              className="text-base text-gray-700 hover:bg-surface font-medium px-2 rounded-md py-1"
                            >
                              {contentItem.title}
                            </Link>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                ));
              })()}
              <AvailabilityLinks />
            </div>
          </section>

          {/* Mobile View */}
          <div className="block md:hidden">
            <div className="mb-8">
              <Image
                src={`${BASE_ASSETS_URL}/v2/clm/clm/BoloSign.png`}
                alt="review"
                className="h-auto mb-2 w-3/4"
                width={100}
                height={100}
                loading="lazy"
              />
              <p className="text-base text-gray-800 my-3 ">
                AI assistant to draft, review, and eSign contracts on autopilot
                for fastest growing companies.
              </p>

              <p className="py-4 text-lg font-medium">
                Email:{" "}
                <Link
                  href="mailto:support@boloforms.com"
                  className="hover:text-primary"
                >
                  support@boloforms.com
                </Link>
              </p>
              <div className="flex gap-4 mb-3 text-4xl md:text-2xl text-black md:text-gray-900">
                {socialLinks.map((link, index) => (
                  <Link
                    key={index}
                    href={link.url}
                    rel="noreferrer"
                    target="_blank"
                    className="text-dark text-sm border border-dark grid place-items-center rounded-full w-8 h-8 transition-all dur hover:bg-dark hover:text-white hover:border-dark"
                  >
                    <span className="sr-only">{link.title}</span>
                    {link.icon}
                  </Link>
                ))}
              </div>
              <div className="flex items-center justify-start gap-4 mt-4">
                {capterraCertifications.map((certification, index) => (
                  <div
                    className="flex flex-col gap-3 justify-end items-center"
                    key={index}
                  >
                    <Image
                      alt={certification?.name}
                      src={certification?.image}
                      width={80}
                      height={80}
                      className="h-16 w-auto"
                      unoptimized
                    />
                  </div>
                ))}
              </div>
            </div>
            {footerElements.map((item, index) => (
              <div key={index} className="border-t border-gray-400 py-2">
                <div
                  className="flex justify-between items-center"
                  onClick={() => toggleSection(item.heading)}
                >
                  <p className="text-xl py-3 font-semibold uppercase">
                    {item.heading}
                  </p>
                  <span className="cursor-pointer text-2xl text-gray-700">
                    {openSections.includes(item.heading) ? (
                      <HiOutlineMinus />
                    ) : (
                      <HiOutlinePlus />
                    )}
                  </span>
                </div>
                {openSections.includes(item.heading) && (
                  <div className="mt-2 pl-1 flex flex-col gap-1 pb-3">
                    {item.content.map((contentItem, contentIndex) => (
                      <Link
                        href={contentItem?.link}
                        className="text-lg"
                        key={contentIndex}
                      >
                        {contentItem.title}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            ))}
            <AvailabilityLinks />
          </div>
        </div>
        <div className="pb-16">
          <Certifications
            certifications={certifications}
            customStyling="gap-4 sm:gap-8"
          />
        </div>

        <footer className=" pb-8 px-6 md:px-8 max-w-screen-xl mx-auto ">
          <div className="flex  justify-center items-start gap-4">
            <span className="text-sm">
              © 2025. Closer Innovation Labs Corp. All rights reserved.
            </span>
          </div>
        </footer>
      </div>
    </>
  );
};

export default CLMFooter;
